module.exports = __webpack_public_path__ + "img/logo.6104bcb4.png";